import React, { useState } from "react";
import ViewerModal from "./ViewModal/ViewModal";
import VideoIcon from "../../../assets/images/videoIcon.svg";

import styles from "./ViewModal/Gallery.module.css";

/**
 * images: array of items:
 * { id, type: 'image'|'video', src: '/images/..', thumb: '/images/thumb-..', title? }
 */
export default function Gallery({ images = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openAt = (index) => {
    setActiveIndex(index);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  const goto = (nextIndex) => {
    const len = images.length;
    const wrapped = (nextIndex + len) % len;
    setActiveIndex(wrapped);
  };

  return (
    <section className={styles.gallerySection}>
      <div className={styles.grid}>
        {images.map((it, i) => (
          <button
            key={it.id || i}
            className={styles.thumbBtn}
            onClick={() => openAt(i)}
            aria-label={`Open ${it.type} ${it.title || i + 1}`}
          >
            <div className={styles.thumb}>
              <img
                src={it.thumb || it.src}
                alt={it.title || `gallery-${i}`}
                className={styles.thumbImg}
              />
              {it.type === "video" && (
                <div className={styles.playOverlay}>
                  <img src={VideoIcon} alt="video" />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {isOpen && (
        <ViewerModal
          items={images}
          index={activeIndex}
          onClose={close}
          onPrev={() => goto(activeIndex - 1)}
          onNext={() => goto(activeIndex + 1)}
          setIndex={setActiveIndex}
        />
      )}
    </section>
  );
}
